"use client"

import { Printer } from "lucide-react"
import { Button } from "@/shared/components/ui/button"

interface PrintButtonProps {
    title?: string
    ariaLabel?: string
    onPreparePrint?: () => void
}

export default function PrintButton({
    title = "Print",
    ariaLabel,
    onPreparePrint,
}: PrintButtonProps) {
    const handlePrint = () => {
        window.scrollTo(0, 0)

        setTimeout(() => {
            onPreparePrint?.()
            window.print()
        }, 50)
    }

    return (
        <Button
            type="button"
            size="sm"
            onClick={handlePrint}
            className="bg-primary hover:bg-primary/90 text-primary-foreground print:hidden"
            title={title}
            aria-label={ariaLabel ?? title}
        >
            <Printer className="w-4 h-4" />
        </Button>
    )
}
